import ReactMarkdown from "react-markdown";

interface RenderIndirectQuestionsProps {
  indirectSentences: string[];
}

export const RenderIndirectQuestions = ({
  indirectSentences,
}: RenderIndirectQuestionsProps) =>
  indirectSentences.map((sentence) => (
    <div key={sentence}>
      <ReactMarkdown>{sentence}</ReactMarkdown>
    </div>
  ));
